export const UPDATE_FOLDER = 'UPDATE_FOLDER';

export function updateFolder(folderList) {
    return {
        type: UPDATE_FOLDER,
        folderList: folderList,
    };
}
